// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
//时间转换控件
import moment from 'moment';//导入文件
Vue.prototype.$moment = moment;//赋值使用
//echat控件
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
//导出excel
import qee from "qf-export-excel";
Vue.prototype.$qee = qee;
//弹窗拖拽js
import './utils/dialog';
//兼容
import 'babel-polyfill';
//公共css
import 'element-ui/lib/theme-chalk/index.css';
import './style/index.scss';
Vue.config.productionTip = false;
Vue.use(ElementUI);

//公用js
import Common from './utils/common';
Vue.prototype.$Common = Common;
//注册全局组件
// import MessageGroup from './components/message-group';
// Vue.component('messageroup', MessageGroup);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js